import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, fileUrl, fmt } from "@/lib/api";

const TYPE_TR = { loss: "Kayıp Bonusu", deposit: "Yatırım Bonusu" };
const PERIOD_TR = { weekly: "Haftalık", monthly: "Aylık" };

const BonusCard = ({ b, onClaim, i }) => (
  <div data-testid={`bonus-card-${b.id}`} className="x-panel overflow-hidden x-rise" style={{ animationDelay: `${i * 0.06}s` }}>
    <div className="relative aspect-[16/7] bg-gradient-to-br from-[#1475e1] to-[#0b3f80]">
      {b.banner_path ? (
        <img src={fileUrl(b.banner_path)} alt={b.title} className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        <div className="absolute inset-0 flex items-center justify-between px-6">
          <div className="text-4xl sm:text-5xl font-black italic">%{fmt(b.percent, 0)}</div>
          <Gift size={64} className="opacity-40" />
        </div>
      )}
    </div>
    <div className="p-4 sm:p-5">
      <div className="flex gap-2 mb-2">
        <span className="x-chip bg-[var(--x-blue)]/20 text-[#7fb6ff]">{TYPE_TR[b.type]}</span>
        <span className="x-chip bg-white/10 text-[var(--x-muted)]">{PERIOD_TR[b.period]}</span>
      </div>
      <div className="text-lg font-extrabold">{b.title}</div>
      {b.description && <p className="text-[13px] text-[var(--x-muted)] mt-1 whitespace-pre-line">{b.description}</p>}
      <div className="mt-4 flex items-center justify-between gap-3 bg-[var(--x-bg-deep)] rounded-lg p-3">
        <div>
          <div className="text-[12px] text-[var(--x-muted)] font-semibold">
            {b.type === "loss" ? "Bu dönem net kayıp" : "Bu dönem yatırım"}: ₺{fmt(b.base)}
          </div>
          <div className="font-extrabold text-[var(--x-green)] tabular-nums" data-testid={`bonus-claimable-${b.id}`}>Alınabilir: ₺{fmt(b.claimable)}</div>
        </div>
        <button data-testid={`bonus-claim-btn-${b.id}`} disabled={!b.claimable} onClick={() => onClaim(b)} className="x-btn x-btn-primary px-5 py-2.5">Talep Et</button>
      </div>
    </div>
  </div>
);

export default function Bonuses() {
  const { refresh } = useAuth();
  const [list, setList] = useState(null);
  const load = () => api.get("/bonuses").then((r) => setList(r.data));
  useEffect(() => {
    load();
  }, []);

  const claim = async (b) => {
    try {
      const { data } = await api.post(`/bonuses/${b.id}/claim`);
      toast.success(`₺${fmt(data.claimed)} bonus bakiyenize eklendi`);
      load();
      refresh();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl sm:text-4xl font-black mb-1">Bonuslar</h1>
      <p className="text-[var(--x-muted)] text-sm mb-6">Bonuslar otomatik hesaplanır, tek tıkla talep edebilirsin.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {list?.map((b, i) => <BonusCard key={b.id} b={b} i={i} onClaim={claim} />)}
      </div>
      {list && list.length === 0 && <div className="x-panel p-8 text-center text-[var(--x-muted)]" data-testid="no-bonuses">Şu an aktif bonus yok</div>}
    </div>
  );
}
